import { Component } from '@angular/core';
import { OAuth2Service} from '../../services/o-auth2.service';
import {Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import {NotifierService} from 'angular-notifier';
import {ErrorMessageService} from '../../services/errorMessage.service';

@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.scss']
  })
export class LoginViewComponent {

  public instructionText: string;
  public loginAtlassianText: string;
  public loginWithoutText: string;
  constructor(
    private loginService: OAuth2Service,
    private router: Router,
    protected translateService: TranslateService,
    private notifier: NotifierService,
    private errorMessageService: ErrorMessageService) {
  }

  ngOnInit(): void {
    const translateInstruction = this.translateService.get('actionview.login.instruction');
    const translateLoginAtlassian = this.translateService.get('actionview.login.login-atlassian');
    const translateLoginWithout = this.translateService.get('actionview.login.login-without');
    forkJoin([translateInstruction, translateLoginAtlassian, translateLoginWithout])
      .subscribe(result => {
        this.instructionText = result[0];
        this.loginAtlassianText = result[1];
        this.loginWithoutText = result[2];
      });
    const errorStatus = this.errorMessageService.getErrorStatus();


    if (errorStatus === 401 || errorStatus === 403 ) {
      this.translateService.get('actionview.login.errorMessage').subscribe(result => {
        this.notifier.notify('error', result);
      });
    }
  }
  public login(): void {
    this.loginService.getAuthorizationUri();
  }

  public continueWithoutLogin(): void{
    this.loginService.deleteAccessToken();
    this.router.navigate(['/taskboard']);
  }
}
